<template>
	<div>
		<span class="content-box-title">
			Usuários
		</span>
		<div class='content-box'>            
			<div class="box-body no-padding">
				<div class="row">
					<div class="col-md-12 right v-padding">
						<button class="btn btn-success" data-toggle="modal" data-target="#newUser">Novo usuário</button>    
					</div>          
				</div>
				<table class="table table-striped" id='standard_tables'>
					<thead>
						<tr>     						
							<th>Nome</th>
							<th>Email</th>
							<th>Nível</th>
							<th>Subdominio</th>
							<th>Status</th>
							<th>Último acesso</th>
							<th>Ações</th>              
						</tr>
					</thead>
					<tbody id="usuarios_tbody">
						<tr v-for='user in users' :key='user.id'>
							<td>{{ user.name}}</td>
							<td>{{ user.email}}</td>
							<td>{{ user.level |nivel_acesso}}</td>
							<td>{{ user.subdomain }}</td>
							<td>{{ user.status}}</td>
							<td>{{ user.updated_at | tempo_passado}}</td>
							<td>
								<button class='btn btn-xs btn-orange btn-interval' title='Editar usuário' @click='edit_show(user.id)'>
									<i class='fa fa-edit'></i>
								</button>
								<button v-show='user.status=="ativo"' class='btn btn-xs btn-gray btn-interval' title='Bloquear usuário' @click='block(user.id)'>
									<i class='fa fa-ban'></i>
								</button>	
								<button  v-show='user.status!="ativo"' class='btn btn-xs btn-green btn-interval' title='Bloquear usuário' @click='unblock(user.id)'>
									<i class='fa fa-check'></i>
								</button>																
								<button class='btn btn-xs btn-red btn-interval' title='Excluir usuário' @click='delete_store(user.id)'>
									<i class='fa fa-trash'></i>
								</button>						
							</td>
						</tr>
					</tbody>
				</table>
			</div>            
		</div>   

		<div class="modal fade" id="newUser" tabindex="-1" role="dialog" aria-labelledby="newUserLabel" aria-hidden="true">			
			<div class="modal-dialog" role="document">
				<form @submit.prevent="form.id ==0 ? newUser_store() : edit_store()" @keydown="form.onKeydown($event)">
					<div class="modal-content">
						<div class="modal-body">
							<span class='content-box-title'>{{ this.modal_title }}</span>
							<input type="hidden" v-model='form.id'>
							<div class="form-group">
								<label>Nome:</label>
								<input v-model="form.name" type="text" name="name"
								class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
								<has-error :form="form" field="name"></has-error>
							</div>
							<div class="form-group">
								<label>Email:</label>
								<input v-model="form.email" type="email" name="email"
								class="form-control" :class="{ 'is-invalid': form.errors.has('email') }">
								<has-error :form="form" field="email"></has-error>
							</div>
							<div class="form-group" v-if="form.id==0">
								<label>Password</label>
								<input v-model="form.password" type="password" name="password"
								class="form-control" :class="{ 'is-invalid': form.errors.has('password') }">
								<has-error :form="form" field="password"></has-error>
							</div>
							<div class="form-group">
								<label>Nível:</label>
								<select v-model="form.level"  name="level"
								class="form-control" :class="{ 'is-invalid': form.errors.has('level') }">
									<option value='admin'>Administrador</option>                    
									<option value='corretor'>Corretor</option>
								</select>
								<has-error :form="form" field="level"></has-error>
							</div>	
							<div class="form-group">
								<label>Sub-domínio:</label>
								<input v-model="form.subdomain" type="text" name="subdomain"
								class="form-control" :class="{ 'is-invalid': form.errors.has('subdomain') }">
								<has-error :form="form" field="subdomain"></has-error>
							</div>							
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
						<button :disabled="form.busy" type="submit" class="btn btn-primary" id="btn_store_new_user">{{this.modal_button_caption}}</button> 
					</div>
				</div>
			</form>
		</div>
	</div>     

     
</div>
</template>

<script>

	var api_url = "/api/apiusuarios";

	export default {
		data(){
			return{
				users:[],
				form: new Form({
					id:0,
					name: '',
					email:'',
					password: '',
					level:'',
					subdomain:""
				})				
			}
		},
		methods:{
			list(){
				axios.get(api_url)
				.then((data)=>{
					console.log(data.data);
					this.users = data.data;
				});
			},
			newUser_show(){
				this.form.reset();
				$("#newUser").modal('show');
			},
			newUser_store(){
				this.form.post(api_url)
					.then((data)=>{
						console.log(data.data);
						$("#newUser").modal('hide');
						this.form.reset();
						Event.$emit('refreshUsuarios');

					});
			},
			edit_show(id){
				axios.get(api_url + "/"+id)
				.then((data)=>{
					var user = data.data;
					this.form.fill(user);
					$("#newUser").modal('show');
				});
			},
			edit_store(){
				this.form.put(api_url + "/" + this.form.id)
					.then((data)=>{
						console.log(data.data);
						$("#newUser").modal('hide');
						this.form.reset();
						Event.$emit('refreshUsuarios');
					})
			},
			delete_store(id){
				axios.delete(api_url + "/" + id)
					.then((data)=>{
						console.log(data.data);						
						Event.$emit('refreshUsuarios');	
					});			
			},
			block(id){
				axios.put(api_url + "/" + id + "/block")
					.then((data)=>{
						console.log(data.data);						
						Event.$emit('refreshUsuarios');	
					});			
			},			
			unblock(id){
				axios.put(api_url + "/" + id + "/unblock")
					.then((data)=>{
						console.log(data.data);						
						Event.$emit('refreshUsuarios');	
					});			
			},				
		},
		computed:{
			modal_title(){
				if (this.form.id ==0) return "Novo usuário";
				return this.form.name;
			},
			modal_button_caption(){
				if(this.form.id==0) return "Cadastrar";
				return "Atualizar";
			}
		},
		created() {
			this.list();
			Event.$on('refreshUsuarios',()=>{
				this.list();
			})
		}
	}
</script>
